<div #container class="container" [ngStyle]="containerStyles">
  <div #content>
    <ng-content />
  </div>
</div>

@if (expandable) {
  <div>
    @if (!expanded) {
      <span>
        (<a href="javascript:;" (click)="onExpandClick(true)">more</a>)
      </span>
    }
    @if (expanded) {
      <span>
        (<a href="javascript:;" (click)="onExpandClick(false)">less</a>)
      </span>
    }
  </div>
}
